package com.wintermar.inspection.feature.presentation.inspection.landing.widget.choose_template

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.core.ui.util.SelectionModel

@Composable
actual fun ChooseTemplateModal(
    show: Boolean,
    title: String,
    labelAction: String,
    labelSecondAction: String,
    templates: List<SelectionModel>,
    onStartInspection: (SelectionModel) -> Unit,
    onDismiss: () -> Unit
) {
    var selectedItem by remember { mutableStateOf<SelectionModel?>(null) }
    var isEmptyChooseTemplate by remember { mutableStateOf(false) }

    ModalDialog(
        show = show,
        title = title,
        action = ModalAction.default().copy(
            withBackgroundHeader = true,
            widthButtonBasedOnText = true,
            showAction = true,
            isSameWeight = true,
            label = labelAction,
            secondLabel = labelSecondAction,
            onClick = {
                selectedItem?.let {
                    isEmptyChooseTemplate = false
                    onStartInspection(it)
                    selectedItem = null
                } ?: run {
                    isEmptyChooseTemplate = true
                }
            },
            secondOnClick = {
                selectedItem = null
                onDismiss()
            }
        ),
        onDismiss = {
            selectedItem = null
            onDismiss()
        }
    ) { verticalPadding ->
        ChooseTemplate(
            templates = templates,
            topPadding = verticalPadding,
            selectedTemplate = selectedItem,
            isEmptyChooseTemplate = isEmptyChooseTemplate,
            onSelectedItem = {
                isEmptyChooseTemplate = false
                selectedItem = it
            }
        )
    }
}
